export default __webpack_public_path__ + "static/media/환자용_예약.27b36a37.png";